const React = require('react');
const { useState, useEffect } = React;
const { default: Styled } = require('styled-components');
const { context } = require('app-context');
const InterestIcon = require('components/PassionInterestItem');

const internals = {};

module.exports = function AboutNerpy({ expanded, name = 'Nerpy' } = {}) {

    const [localOpen, setOpen] = useState(false);
    const open = expanded === undefined ? localOpen : expanded;
    const [profile, setProfile] = useState(null);
    const [error, setError] = useState(false);
    const { Card, Topics, Topic } = internals;
    useEffect(() => {

        let active = true;
        if (open && !profile) {
            setError(false);
            Promise.resolve().then(() => context.api.nearpeer.nerpy.profile()).then((value) => {

                if (active) { setProfile(value); }
            }).catch(() => { if (active) { setError(true); } });
        }
        return () => { active = false; };
    }, [open, profile]);

    const content = <>
        {open && !profile && <p role='status'>{error ? `${name}’s profile is temporarily unavailable. Close and reopen to try again.` : `Loading ${name}’s profile…`}</p>}
        {profile && <>
            {['passions', 'interests'].map((type) => <section key={type}>
                <h3>{type === 'passions' ? 'Passions' : 'Interests'}</h3>
                <Topics>{profile[type].map((interest) => <Topic key={interest.id}>
                    {interest.svg && <InterestIcon svg={interest.svg} interest={interest} />}
                    <span>{interest.name}</span>
                </Topic>)}</Topics>
            </section>)}
        </>}
    </>;

    return expanded === undefined ? <Card onToggle={(event) => setOpen(event.currentTarget.open)}><summary>About {name}</summary>{content}</Card> : <section aria-label={`About ${name}`}>{open && content}</section>;
};

internals.Card = Styled.details`
    padding: 12px 16px;
    border: 1px solid ${({ theme }) => theme.palette?.divider || '#ddd'};
    border-radius: 12px;
    margin: 16px 0;
    summary { cursor: pointer; font-weight: 600; }
    h3 { font-size: 16px; }
`;
internals.Topics = Styled.div`display: flex; flex-wrap: wrap; gap: 12px;`;
internals.Topic = Styled.div`display: flex; align-items: center; gap: 8px;`;
